module.exports = __webpack_public_path__ + "static/media/1.51808ea4.jpg";